// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VQMrh","texts":"styles_texts__4iKSi"};